import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormField } from "../FormField";
import { ResidentFormData } from "../../schemas/residentForm";

interface PpeInfoFormProps {
  disabled?: boolean;
}

export const PpeInfoForm: React.FC<PpeInfoFormProps> = ({ disabled = false }) => {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
  } = useFormContext<ResidentFormData>();

  return (
    <>
      {/* Property Info */}
      <p className="font-bold text-off-black text-base sm:text-lg md:text-[20px]">
        {t("form.ppe.propertyTitle")}
      </p>
      <div className="flex flex-col gap-4 sm:gap-6 md:gap-[24px]">
        <div className="flex gap-4 sm:gap-[16px]">
          <FormField
            label={t("form.ppe.apartmentNumber")}
            className="flex-1 sm:flex-none sm:w-[280px] md:w-[580px]"
          >
            <input
              type="text"
              {...register("numero_appartement")}
              placeholder={t("form.placeholders.apartmentNumber")}
              disabled={disabled}
              className="h-[48px] px-[14px] py-[10px] border border-[#d0d5dd] rounded-[8px] focus:outline-none focus:ring-2 focus:ring-primary text-base text-[#757288]"
            />
          </FormField>
        </div>
      </div>

      {/* Tenant Contact */}
      <p className="font-bold text-off-black text-base sm:text-lg md:text-[20px]">
        {t("form.ppe.tenantContactTitle")}
      </p>
      <div className="flex flex-col gap-4 sm:gap-6 md:gap-[24px]">
        <div className="flex flex-col sm:flex-row gap-4 sm:gap-[16px]">
          <FormField label={t("form.ppe.tenantLastName")} className="flex-1">
            <input
              type="text"
              {...register("locataire_nom")}
              placeholder={t("form.placeholders.lastName")}
              disabled={disabled}
              className="h-[48px] px-[14px] py-[10px] border border-[#d0d5dd] rounded-[8px] focus:outline-none focus:ring-2 focus:ring-primary text-base text-[#757288]"
            />
          </FormField>
          <FormField label={t("form.ppe.tenantFirstName")} className="flex-1">
            <input
              type="text"
              {...register("locataire_prenom")}
              placeholder={t("form.placeholders.firstName")}
              disabled={disabled}
              className="h-[48px] px-[14px] py-[10px] border border-[#d0d5dd] rounded-[8px] focus:outline-none focus:ring-2 focus:ring-primary text-base text-[#757288]"
            />
          </FormField>
        </div>
        <div className="flex flex-col sm:flex-row gap-4 sm:gap-[16px]">
          <FormField
            label={t("form.ppe.tenantHomePhone")}
            error={(errors as Record<string, { message?: string }>).locataire_tel_prive?.message}
            className="flex-1"
          >
            <input
              type="tel"
              {...register("locataire_tel_prive")}
              placeholder={t("form.placeholders.phone")}
              disabled={disabled}
              className="h-[48px] px-[14px] py-[10px] border border-[#d0d5dd] rounded-[8px] focus:outline-none focus:ring-2 focus:ring-primary text-base text-[#757288]"
            />
          </FormField>
          <FormField
            label={t("form.ppe.tenantMobilePhone")}
            error={(errors as Record<string, { message?: string }>).locataire_tel_portable?.message}
            className="flex-1"
          >
            <input
              type="tel"
              {...register("locataire_tel_portable")}
              placeholder={t("form.placeholders.phone")}
              disabled={disabled}
              className="h-[48px] px-[14px] py-[10px] border border-[#d0d5dd] rounded-[8px] focus:outline-none focus:ring-2 focus:ring-primary text-base text-[#757288]"
            />
          </FormField>
        </div>
        <div className="flex gap-4 sm:gap-[16px]">
          <FormField
            label={t("form.ppe.tenantManagement")}
            className="flex-1 sm:flex-none sm:w-[280px] md:w-[580px]"
          >
            <input
              type="text"
              {...register("locataire_gerance")}
              placeholder={t("form.placeholders.management")}
              disabled={disabled}
              className="h-[48px] px-[14px] py-[10px] border border-[#d0d5dd] rounded-[8px] focus:outline-none focus:ring-2 focus:ring-primary text-base text-[#757288]"
            />
          </FormField>
        </div>
      </div>
    </>
  );
};
